// Toast notification utility - Single toast at a time

let toastIdCounter = 0;
let toastListeners = [];

export const toast = {
  success: (message, title = 'Success', duration = 4000) => {
    return addToast({ type: 'success', message, title, duration, autoClose: true });
  },
  
  error: (message, title = 'Error', duration = 5000) => {
    return addToast({ type: 'error', message, title, duration, autoClose: true });
  },
  
  info: (message, title = 'Info', duration = 4000) => {
    return addToast({ type: 'info', message, title, duration, autoClose: true });
  },
  
  warning: (message, title = 'Warning', duration = 4000) => {
    return addToast({ type: 'warning', message, title, duration, autoClose: true });
  }
};

function addToast(toastData) {
  const id = `toast-${++toastIdCounter}`;
  const newToast = { ...toastData, id };
  
  // Notify listeners - they will replace current toast with new one
  toastListeners.forEach(listener => listener(newToast));
  return id;
}

export function subscribeToToasts(callback) {
  toastListeners.push(callback);
  return () => {
    toastListeners = toastListeners.filter(listener => listener !== callback);
  };
}

